import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-slider-simmer',
  templateUrl: './slider-simmer.component.html',
  styleUrls: ['./slider-simmer.component.css']
})
export class SliderSimmerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
